import featureAnalysisReducer from './reducers';
export { default as featureAnalysisOperations } from './operations';
export { default as featureAnalysisTypes } from './types';
export default featureAnalysisReducer;
